package ui.themePlusContext

import adapters.Api
import adapters.Storage
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.coroutineScope
import kotlinx.coroutines.launch
import myConst.StorageAdaptersSealed
import react.*
import ru.malygin.dto.MainScheduleItemDto
import ru.malygin.myConst.ApiReturns
import ru.malygin.myConst.ErrorCode

data class LoadDataContextProp(
    val isLoading: Boolean,
    val mainList: List<MainScheduleItemDto>?,
    val rebuildMainList: () -> Unit
)

val LoadDataContext = createContext<LoadDataContextProp>(
    LoadDataContextProp(
        isLoading = true,
        mainList = null,
        rebuildMainList = {}
    )
)

val LoadDataContextProvider = FC<PropsWithChildren> {
    val ctx = useContext(MyContext)
    val toast = useContext(ToastContext)

    var nameUse by useState(ctx.name)

    var mainList by useState<List<MainScheduleItemDto>?>(Storage.getMainListOrSet()?.data)

    fun buildMainList() {

//        when(val ret = Api().getMainList(
//            groupName = nameUse,
//            category = ctx.category
//        )){
//            is ApiReturns.Error -> {
//                when(ret.code){
//                    ErrorCode.INCORRECT_PARAMETERS_ERROR -> Unit
//                    else -> {
//                        toast.open(
//                            ToastData(
//                                message = ret.code.message,
//                                type = ToastTypes.ERROR,
//                                timeout = 6000
//                            )
//                        )
//                    }
//                }
//            }
//            is ApiReturns.Success -> {
//                setList(ret.data)
//                mainList = ret.data
//            }
//            else -> Unit
//        }
    }

    buildMainList()


    val ctxValue = LoadDataContextProp(
        isLoading = true,
        mainList = mainList,
        rebuildMainList = { buildMainList() }
    )

    LoadDataContext.Provider{
        value = ctxValue

        +it.children
    }
}

fun useLoadDataContext() = useContext(LoadDataContext)

private fun setList(
    mainList: List<MainScheduleItemDto>?
){
    val storage = Storage

    storage.getMainListOrSet(StorageAdaptersSealed.MainList(mainList))
}